import React, { useState } from 'react';
// import { Spin, message } from 'antd';
import DateNavigationHeader from './DateNavigationHeader';
import TaskList from './TaskList';
import { useAuth, returnGrops } from '../../Hooks/UserHooks';
// import { fetchEmployeeInfo, fetchAdminInfo } from '../../fetch/fetch';
// import { useNavigate } from 'react-router-dom';

const RankList: React.FC = () => {
  const [selectedDate, setSelectedDate] = useState('');
  const [hasTasks, setHasTasks] = useState(false);
  const [totalTaskHours, setTotalTaskHours] = useState(0);
  // const [loadingSCC, setLoading] = useState(true);
  // const [timeZone, setTimeZone] = useState<string>(''); 
  const { userProfile } = useAuth();
  // const navigate = useNavigate();
  let jwtToken = '';
  let auth = '';

  if (userProfile) {
    auth = returnGrops(userProfile);
    jwtToken = userProfile.signInUserSession.accessToken.jwtToken;
  }

  const userInitialsFromProfile = String((userProfile as any)?.username || '').trim().slice(0, 2).toUpperCase();
  const userInitials = userInitialsFromProfile || localStorage.getItem('userInitials') || 'AP';

  const handleDateChange = (date: string) => {
    setSelectedDate(date);
  };

  return (
    <div>
        <>
          <DateNavigationHeader 
            onDateChange={handleDateChange} 
            disabled={false}
            hasTasks={() => hasTasks}
            jwtToken={jwtToken}
            totalTaskHours={totalTaskHours}
            userInitials={userInitials}
          />
          <TaskList 
            auth={auth} 
            headerSelectedDate={selectedDate} 
            jwtToken={jwtToken} 
            isManage={false}
            onTasksChange={(tasksCount: number) => setHasTasks(tasksCount > 0)}
            onTotalHoursChange={(totalHours: number) => setTotalTaskHours(totalHours)}
          />
        </>
    </div>
  );
};

export default RankList;
